import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="mb-8 md:mb-0">
            <h3 className="text-2xl font-bold text-green-600 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              MY AVA Farms
            </h3>
            <p className="text-gray-400 mb-4 max-w-md">
              Sustainable BSF farming and pure Ghanaian moringa powder — turning organic resources into premium nutrition for communities across Africa and beyond.
            </p>
            {/* Social Media Links */}
            <div className="flex items-center space-x-3 mt-6">
              <a 
                href="https://wa.me/233233371378" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-green-600 text-white hover:bg-green-700 transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a 
                href="https://web.facebook.com/profile.php?id=61583797453893" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-green-400 transition-colors">About Us</Link></li>
              <li><Link to="/products" className="text-gray-300 hover:text-green-400 transition-colors">Our Products</Link></li>
              <li><Link to="/products" className="text-gray-300 hover:text-green-400 transition-colors">BSF Training</Link></li>
              <li><Link to="/products" className="text-gray-300 hover:text-green-400 transition-colors">Export Services</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-green-400 transition-colors">Blog & Health Tips</Link></li>
              <li><Link to="/partnerships" className="text-gray-300 hover:text-green-400 transition-colors">Partnerships</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line"></i>
                <span className="text-sm">33 Kwame Nkrumah Ave, Adabraka, Accra, Ghana</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line"></i>
                <span className="text-sm">+233 23 337 1378</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line"></i>
                <span className="text-sm">myavagh@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Business Hours</h3>
            <div className="space-y-2 text-gray-300 text-sm">
              <p>Monday - Friday<br />9:00 AM - 5:00 PM</p>
              <p>Saturday<br />9:00 AM - 5:00 PM</p>
              <p>Sunday<br />Closed</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 MY AVA Farms. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-400 hover:text-green-400 text-sm transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-400 hover:text-green-400 text-sm transition-colors">Terms of Service</Link>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-green-400 text-sm transition-colors">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
